module.exports = __webpack_public_path__ + "img/banner_lock.90021e39.png";